import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "anchor",
  "use": "anchor-usage",
  "viewBox": "0 0 116.6 128",
  "content": "<symbol viewBox=\"0 0 116.6 128\" id=\"anchor\"><path fill=\"#fff\" d=\"M115.4 80.7a3.9 3.9 0 0 0-7.3-.5 24.1 24.1 0 0 1-9.8 10 3.9 3.9 0 0 0-1.5 5.3l1.8 3a53.9 53.9 0 0 1-18.5 10.9c-11.5-.6-14.8-17.2-15.1-19-1-8-1.6-16.5-2-23.7h10.8a4.7 4.7 0 1 0 0-9.3H63V39.8a20.2 20.2 0 1 0-9.3 0v17.6H42.8a4.7 4.7 0 1 0 0 9.3h10.7c-.2 7.1-.8 15.6-1.8 23.6-.4 2-3.7 18.5-15.2 19A53.9 53.9 0 0 1 18 98.5l1.8-3a3.9 3.9 0 0 0-1.5-5.4 24.1 24.1 0 0 1-9.8-9.9 3.9 3.9 0 0 0-7.3.5c-.2.7-4.8 17.6 5.4 27.5a4 4 0 0 0 2.7 1.1 4.4 4.4 0 0 0 .5 0 3.9 3.9 0 0 0 2.9-1.8l.3-.6A61.4 61.4 0 0 0 36.7 124a53.6 53.6 0 0 0 21.6 4H60a55.3 55.3 0 0 0 19.9-4 61.3 61.3 0 0 0 23.7-17.1l.3.6a3.9 3.9 0 0 0 2.9 1.8 4.4 4.4 0 0 0 .5 0 4 4 0 0 0 2.7-1c10.2-10 5.6-26.9 5.4-27.6zm-68-60.5a10.9 10.9 0 1 1 11 10.8 10.9 10.9 0 0 1-11-10.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/anchor.svg
// module id = 140
// module chunks = 0